// src/components/CustomerSupportPage/ConfirmationModal.jsx
import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import "../../assets/css/--component-checkoutModal.css";
import successfully from "../../assets/images/successfully.png";
import orderPlacedIcon from "../../assets/images/order-placed.png";
import { Link } from "react-router-dom";

const CheckoutModal = ({
  isOpen,
  toggle,
  title,
  message,
  ButtonText,
  ButtonTextYes,
  icon: CustomIcon,
  onCancel,
  onYes,
  isShowYesButton = false
}) => {

  const handleClose = () => {
    if (onCancel) {
      onCancel();
    } else {
      toggle();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="checkout-modal" backdrop="static" keyboard={false}>
      {/* Close button */}
      <button type="button" className="btn-close-modal" onClick={onCancel} aria-label="Close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <ModalBody className="text-center pt-5 pb-3 checkout-modal-body">
        <div className="modal-icon mb-2">
          <img src={orderPlacedIcon} alt="Order Placed" width="162" height="142" style={{ objectFit: "contain" }} /></div>
        <h3 className="modal-title fw-600 mb-2">ORDER PLACED <span><img className="helo-img" src={successfully} /></span></h3>
        <p className="modal-message">We’ve received your order and our team is already getting it ready. Sit tight—deliciousness is coming soon!</p>
      </ModalBody>
      <ModalFooter className="border-top-0 pt-0 justify-content-center pb-5">
        <button type="button" className="back-dashboard w-80" onClick={toggle}>
          TRACK MY ORDER
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CheckoutModal;
